
import { defineComponent } from "vue";

export default defineComponent({
  name: "GanttGridGroupBar",
  components: {},
  setup() {
    return {};
  }
});
